import styled from '@emotion/styled';
import { tokens, Icon } from '@hotjar/hotsauce';
import type { Recording } from '@hotjar/webapp/domains/recordings/types';

export const Cell = styled.div`
  text-align: center;
  ${tokens.text('caption')};
`;

export const StyledCellIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

export type RecordingOverviewWidgetCellParams = {
  recording?: Recording;
};
